module.exports = __webpack_public_path__ + "img/track.1dfe3b8.svg";